__turbopack_context__.v({
  "chip": "_AGC7q_chip",
  "icon": "_AGC7q_icon",
  "line": "_AGC7q_line",
  "name": "_AGC7q_name",
  "size": "_AGC7q_size",
});
